import React, { useEffect, useState } from 'react';
import { Download, Search } from 'lucide-react';
import * as hr from '../../../api';
import { useHR } from '../../../HRContext';
import { downloadCsv } from './shared';
import Loader from '../../../components/Loader';

// Request Audit Trail (Stephanet's hrrc/adv/AdvAudit.jsx): every create, edit, submit, approval step, assignment, conversion and close.

export default function AdvAudit() {
  const { notify } = useHR();
  const [q, setQ] = useState('');
  const [d, setD] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => hr.advAudit(q).then(setD).catch(e => notify(e.message, 'bad')), 250);
    return () => clearTimeout(t);
  }, [q]); // eslint-disable-line react-hooks/exhaustive-deps
  const exp = () => downloadCsv('advanced_request_audit_trail.csv', ['Ref', 'Changed At', 'Action Type', 'Changed By', 'Old Value', 'New Value', 'Comment'],
    d.rows.map(e => [e.request_no, e.changed_at, e.action_type, e.changed_by, e.old_value, e.new_value, e.comment]));
  return (
    <div>
      <div className="adv-row-between"><h3 className="adv-h3">Request Audit Trail</h3>
        <span className="adv-inline"><span className="mdr-search"><Search size={14} /><input placeholder="Search ref, action or user..." value={q} onChange={e => setQ(e.target.value)} /></span>
          {(d?.can.report || d?.can.view_all) && <button className="mdr-btn" disabled={!d.rows.length} onClick={exp}><Download size={13} /> Export CSV</button>}</span></div>
      <div className="mdr-card mdr-table-card"><div className="mdr-scroll"><table className="mdr-table mds-table">
        <thead><tr>{['Ref', 'Changed At', 'Action Type', 'Changed By', 'Old Value', 'New Value', 'Comment'].map(x => <th key={x}>{x}</th>)}</tr></thead>
        <tbody>
          {!d && <tr><td colSpan={7}><Loader title="Loading…" /></td></tr>}
          {d?.rows.map(e => <tr key={e.id} className="mdr-row"><td className="mono">{e.request_no}</td><td className="nowrap">{e.changed_at}</td><td><span className="lvm-type">{e.action_type}</span></td>
            <td>{e.changed_by}</td><td>{e.old_value || '—'}</td><td>{e.new_value || '—'}</td><td>{e.comment || '—'}</td></tr>)}
          {d && !d.rows.length && <tr><td colSpan={7} className="mdr-empty">No audit entries yet.</td></tr>}
        </tbody></table></div></div>
    </div>
  );
}
